import React from 'react';
import { History } from 'history';
import { Input, InputFile , InputMultiline, InputNumber, InputMoney, InputSwitch, InputPicklist} from '../../components';
import BaseCreate from '../base/base-create.component'; 
import Model from './product-model';  //editable..
import MedialibraryModel from '../medialibrary/medialibrary-model';
import AmounttypeModel from '../amounttype/amounttype-model';
import OwnerPicklist from '../owner/owner-picklist.component';
import ProducttypePicklist from '../producttype/producttype-picklist.component';
import ProductChecklist from './product-checklist.component';
import JournalgroupPicklist from '../journalgroup/journalgroup-picklist.component';
import AmounttypeChecklist from '../amounttype/amounttype-checklist.component';
import ScheduleChecklist from '../schedule/schedule-checklist.component';
import EventPicklist from '../event/event-picklist.component';
import AppService from '../../services/app.service';

interface IProps { 
    history: History;
    caption?: string;
}

interface IState {
    datarow: Model;
    errors: any;
    datarowMedia: any;
}

export default class ProductCreate extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            datarowMedia: null,
        }
        this.onChange = this.onChange.bind(this);
    }
    
    private onLoadOwner = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'owner': data?.id, 'ownerCaption': data?.name || ''  }  });
    }
    
    private onLoadProducttype = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'producttype': data?.id, 'producttypeCaption': data?.name || '', 'producttypeType': data?.type  }  });
    }

    private onLoadProduct = (data: any) => {
        var pricebase = 0;
        var pricesale = 0;
        data?.forEach((datarow: any, i: any) => {
            pricebase = pricebase + datarow.pricebase;
            pricesale = pricesale + datarow.pricesale;
        });
        this.setState({ datarow: { ...this.state.datarow, 'pricebase': pricebase, 'pricesale': pricesale, 'product': data || [], 'productCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    } 

    private onLoadAmounttype = (data: any) => {
        const totalprice = Number(this.state.datarow.pricebase) + Number(this.state.datarow.margin);
        var totalamount = 0;
        data?.forEach((d: any, i: any) => {
            totalamount = totalamount + AmounttypeModel.getCalcValue(d.aspercentage, d.value * d.calcsign, totalprice)
        });
        this.setState({ datarow: { ...this.state.datarow, 'totalamount': totalamount, 'pricesale': totalprice + totalamount, 'amounttype': data || [], 'amounttypeCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''} });
    }  

    private onLoadJournalgroup = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'journalgroup': data?.id, 'journalgroupCaption': data?.name || ''  }  });
    }

    private onLoadEvent = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'event': data?.id, 'eventCaption': data?.name || ''  }  });
    }

    private onLoadSchedule = (data: any) => {
        this.setState({ datarow: { ...this.state.datarow, 'schedule': data || [], 'scheduleCaption': data?.length > 0? (data[0].name) + (data.length>1? ', ...': '') : ''}  });
    }

    private onLoadFile = (data: any) => {
        this.setState({datarowMedia: {...this.state.datarowMedia, endPoint: MedialibraryModel.endPoint, endPointDelete: MedialibraryModel.endPoint2, datarow:{id:this.state.datarow.imageId, files: data, ref: Model.endPointMedia, field:'image'}}});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        var  pricesale = this.state.datarow.pricesale;
        if (fieldName === 'pricebase') pricesale = Number(value) + Number(this.state.datarow.margin) + Number(this.state.datarow.totalamount)
        else if (fieldName === 'margin') pricesale = Number(this.state.datarow.pricebase) + Number(value) + Number(this.state.datarow.totalamount);
        
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value, pricesale: pricesale
            }
        }
        this.setState(nextState);
    }

    render() {
        return (
            //editable..          
            <BaseCreate history={this.props.history} 
                model={Model} datarow={this.state.datarow} datarowMedia={this.state.datarowMedia} onError={this.onError}>               
          
                <InputSwitch name='status' label='Status' value={this.state.datarow.status} options={Model.optionStatus} error={this.state.errors?.status} onChange={this.onChange}/>
                <Input name='name' label='Name' value={this.state.datarow.name} error={this.state.errors?.name} onChange={this.onChange} />
                <InputMultiline name='description' label='Description' value={this.state.datarow.description} error={this.state.errors?.description} onChange={this.onChange} />
                {AppService.isAppFullVersion() &&
                <InputPicklist name='owner' label='Owner' value={this.state.datarow.owner} caption={this.state.datarow.ownerCaption} error={this.state.errors?.owner} onChange={this.onChange} >
                    <OwnerPicklist currentId={this.state.datarow.owner} onLoad={this.onLoadOwner}/>
                </InputPicklist>
                } 
                <InputPicklist name='producttype' label='Product Type' value={this.state.datarow.producttype} caption={this.state.datarow.producttypeCaption} error={this.state.errors?.producttype} onChange={this.onChange} >
                    <ProducttypePicklist currentId={this.state.datarow.producttype} onLoad={this.onLoadProducttype}/>
                </InputPicklist> 
                <Input name='unit' label='Unit' value={this.state.datarow.unit} error={this.state.errors?.unit} onChange={this.onChange} />
                <InputNumber name='qty' label='Qty' value={this.state.datarow.qty} error={this.state.errors?.qty} onChange={this.onChange} />
                <InputNumber name='qtymin' label='Qty Min' value={this.state.datarow.qtymin} error={this.state.errors?.qtymin} onChange={this.onChange} />
                <InputNumber name='qtymax' label='Qty Max' value={this.state.datarow.qtymax} error={this.state.errors?.qtymax} onChange={this.onChange} />
                <InputMoney name='pricebase' label='Price Base' value={this.state.datarow.pricebase} error={this.state.errors?.pricebase} onChange={this.onChange} />
                <InputMoney name='margin' label='Margin' value={this.state.datarow.margin} error={this.state.errors?.margin} onChange={this.onChange} />
                <InputPicklist name='amounttype' label='Addional Value List' value={this.state.datarow.amounttype} caption={this.state.datarow.amounttypeCaption} disableAutoClose clearValue={this.onLoadAmounttype} error={this.state.errors?.amounttype} onChange={this.onChange} >
                    <AmounttypeChecklist history={this.props.history} currentId={this.state.datarow.amounttype} onLoad={this.onLoadAmounttype} disableBackButton/>
                </InputPicklist> 
                <InputMoney name='totalamount' label='Total Addional Values' value={this.state.datarow.totalamount} readOnly/>
                <InputMoney name='pricesale' label='Price Sale' value={this.state.datarow.pricesale} error={this.state.errors?.pricesale} onChange={this.onChange} />
                <InputFile name='imageUrl' label='Image' value={this.state.datarow.imageUrl} type='image' onLoad={this.onLoadFile} error={this.state.errors?.image} onChange={this.onChange} />
                <InputPicklist name='product' label='Sub Product List' value={this.state.datarow.product} caption={this.state.datarow.productCaption} disableAutoClose clearValue={this.onLoadProduct} error={this.state.errors?.product} onChange={this.onChange} >
                    <ProductChecklist history={this.props.history} currentId={this.state.datarow.product} onLoad={this.onLoadProduct} disableBackButton/>
                </InputPicklist>  
                <InputPicklist name='journalgroup' label='Journal Group' value={this.state.datarow.journalgroup} caption={this.state.datarow.journalgroupCaption} error={this.state.errors?.journalgroup} clearValue={this.onLoadJournalgroup} onChange={this.onChange} >
                    <JournalgroupPicklist currentId={this.state.datarow.journalgroup} onLoad={this.onLoadJournalgroup}/>
                </InputPicklist> 
                {this.state.datarow.producttypeType==='events' &&
                <>
                <InputPicklist name='event' label='Event' value={this.state.datarow.event} caption={this.state.datarow.eventCaption} error={this.state.errors?.event} clearValue={this.onLoadEvent} onChange={this.onChange} >
                    <EventPicklist currentId={this.state.datarow.event} astemplate='yes' onLoad={this.onLoadEvent}/>
                </InputPicklist> 
                <InputPicklist name='schedule' label='Schedule List' value={this.state.datarow.schedule} caption={this.state.datarow.scheduleCaption} disableAutoClose clearValue={this.onLoadSchedule} error={this.state.errors?.schedule} onChange={this.onChange} >
                    <ScheduleChecklist history={this.props.history} currentId={this.state.datarow.schedule} onLoad={this.onLoadSchedule} disableBackButton/>
                </InputPicklist> 
                </>
                }

            </BaseCreate>
        );
    }     
     
}